import { Component, Input, OnInit } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { DocumentService } from '../../service/document.service';
import { SearchDocumentInfoCriteria } from '../../models/SearchDocumentInfoCriteria';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { Constants } from 'src/app/shared/model/Constants';
import { DocumentInfoSearchResultItem } from '../../models/DocumentInfoSearchResultItem';
import { Observable, tap } from 'rxjs';
import { DocumentType } from 'src/app/shared/model/DocumentType';


@Component({
  selector: 'app-claim-documents-select',
  templateUrl: './claim-documents-select.component.html',
  styleUrls: ['./claim-documents-select.component.scss']
})
export class ClaimDocumentsSelectComponent extends DialogContentBase implements OnInit {

  constructor(public dialog: DialogRef,
    private documentService: DocumentService) {
    super(dialog);
  }

  @Input() claimIdentifier:string;
  selectedDocumentInfos:DocumentInfoSearchResultItem[] = [];
  searchDocumentInfoCriteria: SearchDocumentInfoCriteria;
  isLoading:boolean;
  documentInfos$: Observable<DocumentInfoSearchResultItem[]>;
  
  
 ngOnInit(): void {
    this.loadDocuments();
  }


  loadDocuments() {
    this.searchDocumentInfoCriteria = {
      referenceType: ReferenceType.Claim,
      referenceId: this.claimIdentifier,
      documentKindId: null,
      pageNumber: 1,
      rowsPerPage: Constants.MaxInt,
      documentTypeIds: [
        DocumentType.ClaimDocumentation, 
        DocumentType.CostEstimation, 
        DocumentType.InspectionCard,
        DocumentType.CarReceptionDataProtocol,
        DocumentType.CarReceptionDataReturnProtocol
      ],
      sortDirection: ''
    }

    this.isLoading = true;
    this.documentInfos$ = this.documentService.searchDocumentInfo(this.searchDocumentInfoCriteria).pipe(
      tap(() => { this.isLoading = false; }));
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  confirm() {
    const ids = this.selectedDocumentInfos.map(x => x.id);
    this.documentService.getExportDocumentsData(ids).subscribe(
          (res) => {
            this.dialog.close({ text: 'OK' , selected: res.exportDocumentItems});
          });
  }

  selectItem(event: any, documentInfo: DocumentInfoSearchResultItem) {
    if (event.target.checked) {
      this.selectedDocumentInfos.push(documentInfo);
    } else {
      this.selectedDocumentInfos = this.selectedDocumentInfos.filter(x => x.id !== documentInfo.id);
    }
  }
  
}
